import React from 'react';

const CommunicationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === 'small' ? '27.849' : '40'}
    height={props.size === 'small' ? '23' : '40'}
    viewBox="0 0 40 40"
  >
    <g id="Group_11" data-name="Group 11" transform="translate(-4 -4)">
      <path
        id="Path_18"
        data-name="Path 18"
        d="M24,10A14.015,14.015,0,0,0,10,24a13.847,13.847,0,0,0,1.228,5.691,1,1,0,0,0,1.826-.816A11.854,11.854,0,0,1,12,24a12,12,0,0,1,24,0,11.854,11.854,0,0,1-1.054,4.875,1,1,0,0,0,1.826.816A13.847,13.847,0,0,0,38,24,14.015,14.015,0,0,0,24,10Z"
      />
      <path
        id="Path_19"
        data-name="Path 19"
        d="M24,4A19.955,19.955,0,0,0,7.489,35.228,1,1,0,0,0,9.14,34.1,17.839,17.839,0,0,1,6,24a18,18,0,0,1,36,0,17.839,17.839,0,0,1-3.14,10.1,1,1,0,0,0,1.651,1.129A19.955,19.955,0,0,0,24,4Z"
      />
      <circle
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="7"
        cy="7"
        r="7"
        transform="translate(17 17)"
      />
      <path
        id="Path_21"
        data-name="Path 21"
        d="M11,0c6.075,0,9.891,2.36,11,6.5S23.252,13,11,13,0,10.09,0,6.5,4.925,0,11,0Z"
        transform="translate(13 31)"
      />
    </g>
  </svg>
);

CommunicationIcon.defaultProps = {
  size: 'medium',
};

export default CommunicationIcon;
